export default __webpack_public_path__ + "static/media/serverless_aws.379816c6.svg";